export function cloneObject<T>(obj: T) {
  return JSON.parse(JSON.stringify(obj));
}
